module.exports = __webpack_public_path__ + "banquet/components/images/lock.d914653d237a41b5fd74c16106a44358.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/lock.svg
// module id = 1709
// module chunks = 1